import { render, staticRenderFns } from "./DiscoverFiltersModal.vue?vue&type=template&id=5a33f61c&scoped=true&"
import script from "./DiscoverFiltersModal.vue?vue&type=script&lang=ts&"
export * from "./DiscoverFiltersModal.vue?vue&type=script&lang=ts&"
import style0 from "./DiscoverFiltersModal.vue?vue&type=style&index=0&id=5a33f61c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a33f61c",
  null
  
)

export default component.exports